import { render, staticRenderFns } from "./project_way_index.vue?vue&type=template&id=35bfb43e&"
import script from "./project_way_index.vue?vue&type=script&lang=js&"
export * from "./project_way_index.vue?vue&type=script&lang=js&"
import style0 from "./project_way_index.vue?vue&type=style&index=0&id=35bfb43e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports